<template>
  <div>
    <div>
      <img
        class="backImg"
        :src="
          language === 'zh'
            ? require('@/assets/images/companyProfile/backgroundImg000.jpg')
            : require('@/assets/images/companyProfile/en_backgroundImg000.jpg')
        "
      />
    </div>
    <div class="bread">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="24" :sm="21" :md="20" :lg="18" :xl="16">
          <slot name="breadcrumb"></slot>
        </el-col>
      </el-row>
    </div>

    <div class="container">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="24" :sm="21" :md="20" :lg="18" :xl="16">
          <div class="contentBox">
            <div class="leftBox">
              <div class="menuTitle">
                <span>{{ $t("route.companyProfile") }}</span>
              </div>
              <div
                :class="activeIndex == item.id ? 'activemenu' : 'menu'"
                v-for="(item, index) in companyProfileList"
                :key="index"
                @click="menuClick(item.path, item.id)"
              >
                <div :class="activeIndex == item.id ? 'sign' : ''"></div>
                <div class="menu-title">{{ item.title }}</div>
                <!-- <div class="menu-to">
                  <i class="el-icon-arrow-right" style="font-size: 14px"></i>
                </div> -->
              </div>
            </div>
            <div class="rightBox">
              <div class="boxTitle">
                <div>{{ temp.title }}</div>
                <!-- <div v-if="(activeIndex == 3007)" class="year">
                  <div 
                    :class="yearIndex == item ? 'year-activefont' : 'year-font'" 
                    v-for="(item, index) in yearData" 
                    :key="index" 
                    @click="yearClick(item)">{{ item }}</div>
                </div> -->
              </div>
              <!-- 企业文化 -->
              <div v-if="activeIndex == 3005">
                <article-center-detail
                  v-if="cardData.length === 1"
                  :id="cardData[0].id"
                  :typeData="2"
                  ref="articleCenterDetail"
                />
                <div v-else>
                  <el-card
                    style="margin-top: 20px"
                    v-for="(item, index) in cardData"
                    :key="index"
                  >
                    <div class="content in" style="margin-top: 0">
                      <img class="boxImg" :src="item.pic" />
                      <div v-html="xss(item.content)"></div>
                    </div>
                  </el-card>
                </div>
              </div>
              <!-- 发展历程 -->
              <!-- <div v-if="activeIndex == 3007">
                <div class="content">
                  <div class="dateTime">
                    <div
                      :style="{
                        visibility:
                          yearListQuery.page != 1 ? 'visible' : 'hidden',
                      }"
                    >
                      <i
                        class="el-icon-arrow-left"
                        @click="changeYear('left')"
                      ></i>
                    </div>
                    <div class="year">
                      <div
                        :class="
                          yearIndex == item.title
                            ? 'year-activefont'
                            : 'year-font'
                        "
                        v-for="(item, index) in yearData"
                        :key="index"
                      >
                        <div class="year-title" @click="yearClick(item.title)">
                          {{ item.title }}年
                        </div>
                        <div
                          @click="yearClick(item.title)"
                          :class="
                            yearIndex == item.title ? 'activeradius' : 'radius'
                          "
                        ></div>
                        <div class="line"></div>
                      </div>
                    </div>
                    <div v-if="yearListQuery.page != yearListQuery.totalPages">
                      <i
                        class="el-icon-arrow-right"
                        @click="changeYear('right')"
                      ></i>
                    </div>
                  </div>
                  <div
                    v-for="(item, index) in cardData"
                    :key="index"
                    class="timeline"
                  >
                    <div
                      class="timeline-item"
                      v-for="(jtem, index) in item.subList"
                      :key="index"
                    >
                      <div>
                        <img class="timeline-item-img" :src="jtem.pic" />
                      </div>
                      <div class="timeline-item-content">
                        <div class="timeline-item-title">
                          {{
                            jtem.input_date.substring(
                              0,
                              jtem.input_date.lastIndexOf("-")
                            )
                          }}
                        </div>
                        <div>{{ jtem.content }}</div>
                      </div>
                    </div>
                    <div v-if="cardData.length === 0" class="noData">
                      暂无数据
                    </div>
                  </div>
                </div>
              </div> -->
              <div v-if="activeIndex == 3007">
                <ul class="timeline2">
                  <li v-for="item in cardData" class="timeline2-item">
                    <div class="timeline2-item-tail"></div>
                    <div class="timeline2-item-node">
                      <span>{{ item.year }}年</span>
                    </div>
                    <div class="timeline2-item-nodeline"></div>
                    <div class="timeline2-item-content">
                      <div class="timeline2-item-box" v-for="jtem in item.list">
                        <div class="timeline2-item-date">
                          <div class="timeline2-item-sign"></div>
                          <div>{{ jtem.month }}</div>
                        </div>
                        <div class="timeline2-item-remark">
                          <div class="timeline2-item-remarkContent">
                            {{ jtem.content }}
                          </div>
                          <div>
                            <img
                              class="timeline2-item-img"
                              :src="jtem.pic"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <articleCenter
                v-if="
                  [3008, 3009, 3010, 3013, 3004, 3006].includes(+activeIndex)
                "
                :typeName="2"
                ref="articleCenter"
              ></articleCenter>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { routeName, parseTime } from "@/utils/index";
import * as acticleApi from "@/api/acticle/acticle";
import articleCenter from "@/views/pilotService/articleCenter/articleCenter";
import ArticleCenterDetail from "../pilotService/articleCenter/articleCenterDetail.vue";
import { mixins } from "@/mixins/list";
export default {
  components: { articleCenter, ArticleCenterDetail },
  mixins: [mixins],
  data() {
    return {
      language: localStorage.getItem("language") || "zh",
      id: "",
      activeIndex: 3004,
      yearIndex: new Date().getFullYear(),
      yearData: [],
      yearListQuery: {
        id: 3007,
        // page: 1,
        // size: 5,
        // totalPages: 0,
      },
      cardData: [],
      temp: {
        title: "",
      },
      pathName: "",
    };
  },
  created() {
    this.yearData = [];
    this.setRouteName();
  },
  watch: {
    $route: "setRouteName",
  },
  methods: {
    setRouteName() {
      const pathName = routeName(this.$route.path);
      this.pathName = pathName;
      this.temp = this.companyProfileList.find((item) => {
        return +item.id === +this.pathName;
      });
      this.activeIndex = +this.temp.id;

      this.load();
    },
    load() {
      if (+this.pathName === 3007) {
        this.yearClick();
      }
      if (
        ![3008, 3009, 3010, 3013, 3004, 3006, 3007].includes(+this.activeIndex)
      ) {
        acticleApi.getIndex({ id: this.pathName }).then((res) => {
          this.cardData = res.data.data;
        });
      }
    },
    menuClick(path, index) {
      if (this.activeIndex !== index) {
        this.activeIndex = index;
        this.$router.push(path);
        this.$emit("resetScrollTop", "bread");
      }
    },
    // changeYear(val) {
    //   if (val == "left" && this.yearListQuery.page != 1) {
    //     this.yearListQuery.page = this.yearListQuery.page - 1;
    //     this.load();
    //   }
    //   if (
    //     val == "right" &&
    //     this.yearListQuery.page != this.yearListQuery.totalPages
    //   ) {
    //     this.yearListQuery.page = this.yearListQuery.page + 1;
    //     this.load();
    //   }
    // },
    yearClick(year) {
      // this.yearIndex = year;
      this.cardData = [];
      acticleApi
        .getYearChildData({ id: this.activeIndex })
        .then((res) => {
          this.cardData = res.data;
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.bread {
  background-color: #f6f6f6;
  padding: 15px 20px;
}
.backImg {
  width: 100%;
  /* height: 300px; */
}
.container {
  padding: 40px 20px;
}
.contentBox {
  display: flex;
}
.leftBox {
  width: 20%;
  margin-right: 20px;
}
.menuTitle {
  padding: 10px;
  background-color: #32589f;
  /* text-align: center; */
  font-weight: 700;
  font-size: 18px;
}
.menuTitle > span {
  color: #fff;
  margin-left: 13px;
}
.activemenu {
  padding: 15px 10px;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  /* border: 1px solid #dcdfe6; */
  border-top: 0px;
  cursor: pointer;
}
.activemenu > div {
  color: #32589f;
  font-weight: 800;
}
.menu {
  padding: 15px 10px;
  display: flex;
  /* justify-content: space-between; */
  /* border: 1px solid #dcdfe6; */
  border-top: 0px;
  cursor: pointer;
  background-color: rgba(245, 245, 245, 1);
}
.menu:hover {
  background-color: #ecf8ff;
}
.menu:hover > div {
  color: #32589f;
  font-weight: 800;
}
.menu > div {
  color: #333;
}
.menu-title {
  margin-left: 8px;
}
.menu .menu-title {
  margin-left: 13px;
}
.rightBox {
  padding: 5px;
  width: 100%;
  overflow: hidden;
}
.boxTitle {
  font-size: 22px;
  font-weight: 800;
  padding-bottom: 10px;
  color: #015a9c;
  border-bottom: 1px solid #dcdfe6;
  letter-spacing: 2px;
}
.sign {
  width: 5px;
  height: 17px;
  background-color: #32589f;
  border-radius: 20px;
}
.content {
  font-family: "Arial Normal", "Arial";
  color: #333;
  font-size: 15px;
  margin-top: 20px;
  letter-spacing: 2px;
  text-align: justify;
}
.dateTime {
  width: 100%;
  display: flex;
  /* justify-content: center; */
  /* align-items: flex-end; */
}
.dateTime > div .el-icon-arrow-left {
  margin-right: 20px;
  margin-top: 40px;
  cursor: pointer;
}
.dateTime > div .el-icon-arrow-right {
  /* margin-left: 20px; */
  margin-top: 40px;
  cursor: pointer;
}
.year {
  display: flex;
  justify-content: center;
  /* justify-content: space-around; */
  align-items: center;
  width: 100%;
}
.year-title {
  margin-left: -20px;
  cursor: pointer;
}
.radius {
  width: 15px;
  height: 15px;
  background-color: #fff;
  border: 1px solid #015a9c;
  border-radius: 50%;
  position: relative;
  z-index: 33;
  top: 12px;
  left: -2px;
  cursor: pointer;
}
.activeradius {
  width: 15px;
  height: 15px;
  background-color: #015a9c;
  border: 1px solid #fff;
  border-radius: 50%;
  position: relative;
  z-index: 33;
  top: 12px;
  left: -2px;
  cursor: pointer;
}
/* .year > div:first-child .radius,.activeradius {
  margin-left: 20px;
} */
.year > div:last-child .radius,
.activeradius {
  margin-right: 20px;
}
.line {
  /* width: 150px; */
  width: 12.5vw;
  height: 5px;
  background-color: #015a9c;
}
.year > div:last-child .line {
  width: 0;
}
.year-font {
  font-weight: 800;
  color: #333;
  letter-spacing: 0px;
}
.year-activefont {
  font-weight: 800;
  letter-spacing: 0px;
  color: #32589f;
}
.timeline-item {
  margin-top: 20px;
  display: flex;
}
.timeline:nth-child(2n-1) .timeline-item {
  display: flex;
  flex-direction: row-reverse;
}
.timeline-item-img {
  width: 380px;
  height: 200px;
  margin-right: 10px;
}
.timeline-item-title {
  font-weight: 800;
  font-size: 18px;
  margin-top: 50px;
  margin-bottom: 20px;
}
.timeline:nth-child(2n-1) .timeline-item .timeline-item-img {
  margin-left: 10px;
}
.timeline:nth-child(2n-1) .timeline-item .timeline-item-title {
  text-align: right;
}
.in {
  display: flex;
}
.bottom {
  margin-bottom: 10px;
}
.bottom:last-child {
  margin-bottom: 0;
}
.boxImg {
  width: 180px;
  height: 150px;
  margin-right: 20px;
}
/* .date {
  margin-right: 40px;
} */
/* .year {
  display: -webkit-inline-box;
  max-width: 75%;
  overflow: auto;
  font-size: 15px;
} */
.el-timeline {
  margin-left: -40px;
}
.content /deep/.el-timeline-item__timestamp {
  color: #32589f;
  font-size: 18px;
  font-weight: 800;
}
.content /deep/.el-timeline-item__timestamp.is-top {
  padding-top: 0px;
  margin-bottom: 20px;
}
.noData {
  opacity: 0.5;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  line-height: 3;
}
.timeline2 {
  font-size: 14px;
  list-style: none;
  margin-top: 20px;
  /* margin-left: -40px; */
}
.timeline2-item {
  position: relative;
  padding-bottom: 20px;
}
.timeline2-item-tail {
  position: absolute;
  top: 45px;
  left: 50px;
  height: calc(100% - 55px);
  border-left: 2px solid #4284b5;
}
.timeline2-item-node {
  position: absolute;
  background-color: #015a9c;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #fcfbfa;
  font-weight: bolder;
  height: 35px;
  width: 100px;
}
.timeline2-item-nodeline {
  position: relative;
  width: 20px;
  height: 2px;
  top: 17.5px;
  left: 110px;
  background-color: #4284b5;
}
.timeline2-item-content {
  position: relative;
  left: 140px;
  top: -3px;
  width: 70%;
}
.timeline2-item-box {
  padding: 15px;
  background-color: #f4f4f4;
  margin-bottom: 20px;
}
.timeline2-item-date {
  display: flex;
  align-items: center;
  column-gap: 10px;
  font-size: 16px;
  font-weight: 800;
  color: #015a9c;
  border-bottom: 1px solid #dcdfe6;
  padding-bottom: 7px;
}
.timeline2-item-sign {
  width: 5px;
  height: 17px;
  background-color: #32589f;
  border-radius: 20px;
}
.timeline2-item-remark {
  margin-top: 15px;
  display: flex;
  column-gap: 30px;
}
.timeline2-item-remarkContent {
  width: calc(100% - 15vmax - 15px);
  text-align: justify;
  font-size: 16px;
  line-height: 35px;
  white-space: pre-line;
  margin-top: -35px;
}
.timeline2-item-img {
  width: 15vmax;
  height: 10vmax;
  border-radius: 10px;
}
@media only screen and (max-width: 768px) {
  .backImg {
    width: 100%;
    height: auto;
  }
  .contentBox {
    display: block;
  }
  .leftBox {
    width: 100%;
    margin-right: 0;
    margin-bottom: 10px;
  }
  .boxTitle {
    font-size: 17px;
    letter-spacing: 0px;
  }
  .rightBox {
    padding: 0;
  }
  .content {
    margin-top: 10px;
    font-size: 14px;
  }
  .in {
    display: block;
  }
  .boxImg {
    width: 100%;
    margin-bottom: 10px;
  }
  .year {
    font-size: 12px;
  }
  .dateTime > div .el-icon-arrow-left {
    /* margin-right: 10px; */
    letter-spacing: 0;
  }
  .dateTime > div .el-icon-arrow-right {
    /* margin-left: 10px; */
    letter-spacing: 0;
  }
  .line {
    width: 60px;
  }
  .timeline-item {
    margin-top: 20px;
    display: flex;
  }
  .timeline-item-img {
    width: 180px;
    height: 100px;
    margin-right: 10px;
  }
  .timeline-item-title {
    font-weight: 800;
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .timeline2 {
    margin-left: -40px;
  }
  .timeline2-item-tail {
    position: absolute;
    top: 35px;
    left: 30px;
    height: calc(100% - 45px);
    border-left: 2px solid #c2d8e7;
  }
  .timeline2-item-node {
    font-size: 16px;
    height: 25px;
    width: 60px;
  }
  .timeline2-item-nodeline {
    position: relative;
    width: 20px;
    height: 2px;
    top: 12.5px;
    left: 70px;
  }
  .timeline2-item-content {
    position: relative;
    left: 100px;
    top: -3px;
  }
  .timeline2-item-date {
    font-size: 14px;
  }
  .timeline2-item-remark {
    margin-top: 15px;
    display: flex;
    flex-direction: column-reverse;
  }
  .timeline2-item-remarkContent {
    font-size: 13px;
    line-height: 20px;
    margin-top: -10px;
    width: 100%;
  }
  .timeline2-item-img {
    width: 100%;
    height: auto;
    border-radius: 10px;
  }
}
</style>